import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "empty", "panel", "search", "section", "tab"]

  connect() {
    this.activeSource = this.visiblePanel?.dataset.agentSource
    this.filter()
  }

  select(event) {
    this.activeSource = event.params.source

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.agentSource !== this.activeSource
    })

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.agentDirectorySourceParam === this.activeSource
      tab.classList.toggle("active", active)
      tab.setAttribute("aria-selected", active ? "true" : "false")
    })

    this.filter()
  }

  filter() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""
    const panel = this.visiblePanel
    if (!panel) return

    let visibleCards = 0
    this.cardsIn(panel).forEach((card) => {
      const visible = !query || card.dataset.agentSearchText.includes(query)
      card.hidden = !visible
      if (visible) visibleCards += 1
    })

    this.sectionsIn(panel).forEach((section) => {
      section.hidden = this.cardsIn(section).every((card) => card.hidden)
    })

    const empty = this.emptyTargets.find((target) => panel.contains(target))
    if (empty) empty.hidden = visibleCards > 0
  }

  get visiblePanel() {
    return this.panelTargets.find((panel) => !panel.hidden)
  }

  cardsIn(element) {
    return this.cardTargets.filter((card) => element.contains(card))
  }

  sectionsIn(element) {
    return this.sectionTargets.filter((section) => element.contains(section))
  }
}
